import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from '@angular/router';

import { StoreService } from "../../core/store.service";
import { NavigationService } from "../../core/navigation.service";
import { ProgressBarService } from '../../core/progress-bar.service';

@Component({
  selector: 'insurance',
  templateUrl: './insurance.component.html',
})
export class InsuranceComponent implements OnInit {

  title = 'Insurance Information';
  progressBar = this.progress.insurance;
  insurances: Array<string> = this.store.state.insurances;
  text = '';
  otherInsuranceName = '';
  showFields = false;
  states: Array<string> = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
  showSecondInsurance = false;
  showAddSecondInsuranceButton = false;
  showSecondInsuranceFields = false;
  otherSecondInsuranceName = '';

  insurance = {
    name: '',
    memberId: '',
    groupId: '',
    subscriberName: '',
    subscriberDob: null,
    address: null
  }

  address = {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: ''
  }

  insuranceSecond = {
    name: '',
    memberId: '',
    groupId: '',
    subscriberName: '',
    subscriberDob: null,
    address: null
  }

  addressSecond = {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: ''
  }

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  ngOnInit(): void {
    // First Insurance
    if (this.store.state.consent.insurances.length > 0) {
      this.insurance = this.store.state.consent.insurances[0];

      if (this.insurance && this.insurance.name !== 'NO INSURANCE') {
        if (this.insurance.address !== null) {
          this.address = this.insurance.address;
        }
        this.showFields = true;
      }

      // Second Insurance
      this.insuranceSecond = this.store.state.consent.insurances[1];

      if (this.insuranceSecond && this.insuranceSecond.name !== 'NO INSURANCE') {
        if (this.insuranceSecond.address !== null) {
          this.addressSecond = this.insuranceSecond.address;
        }

        this.showSecondInsurance = true;
        this.showSecondInsuranceFields = true;
      }
    }
 }

  clearFields() {
    this.showFields = false;
    this.insurance.memberId = '';
    this.insurance.groupId = '';
    this.insurance.subscriberName = '';
    this.insurance.subscriberDob = null;
    this.insurance.address = null;

    this.address.addressLine1 = '';
    this.address.addressLine2 = '';
    this.address.city = '';
    this.address.state = '';
    this.address.zip = '';

    this.otherInsuranceName = '';
  }

  clearSecondInsuranceFieldsFields() {
    this.showSecondInsuranceFields = false;
    this.insuranceSecond.memberId = '';
    this.insuranceSecond.groupId = '';
    this.insuranceSecond.subscriberName = '';
    this.insuranceSecond.subscriberDob = null;
    this.insuranceSecond.address = null;

    this.addressSecond.addressLine1 = '';
    this.addressSecond.addressLine2 = '';
    this.addressSecond.city = '';
    this.addressSecond.state = '';
    this.addressSecond.zip = '';

    this.otherInsuranceName = '';
  }

  selectInsurance(insurance: string) {
    if (insurance === '' || insurance === 'NO INSURANCE') {
      this.clearFields();
    } else {
      this.showFields = true;
      this.showAddSecondInsuranceButton = true;
    }
  }

  selectSecondInsurance(insurance: string) {
    if (insurance === '' || insurance === 'NO INSURANCE') {
      this.clearFields();
    } else {
      this.showSecondInsuranceFields = true;
    }
  }

  isSubscriberDobValid(): boolean {
    if (this.insurance.name === 'NO INSURANCE') {
      return true;
    }

    if (!this.insurance || !this.insurance.subscriberDob) {
      return false;
    }

    // Validate if it's a proper date
    const dob = new Date(this.insurance.subscriberDob);
    return dob instanceof Date && !isNaN(dob.getTime()) && dob.getFullYear() >= 1900;
  }


  back() {
    this.router.navigate([this.navigation.insurance.back]);
  }

  addSecondInsurance() {
    this.showSecondInsurance = true;
  }

  next() {

    // First Insurance
    if (this.insurance.name === 'OTHER') {
      this.insurance.name = this.otherInsuranceName;
    }

    if (this.address.addressLine1 !== ''
      || this.address.addressLine2 !== ''
      || this.address.city !== ''
      || this.address.state !== ''
      || this.address.zip !== '') {
      this.insurance.address = this.address;
    }

    this.store.state.consent.insurances.push(this.insurance);


    // Second Insurance
    if (this.insuranceSecond.name === 'OTHER') {
      this.insuranceSecond.name = this.otherSecondInsuranceName;
    }

    if (this.addressSecond.addressLine1 !== ''
      || this.addressSecond.addressLine2 !== ''
      || this.addressSecond.city !== ''
      || this.addressSecond.state !== ''
      || this.addressSecond.zip !== '') {
      this.insuranceSecond.address = this.addressSecond;
    }

    this.store.state.consent.insurances.push(this.insuranceSecond);


    this.router.navigate([this.navigation.insurance.next]);
  }
}
